import { SEASONAL_FEATURE_IDS } from 'root/lib/constants';

const initState = {
  // What special seasonal themes, bonuses or adjustments should be toggled on?
  seasonalAdjustmentFeatures: {
    [SEASONAL_FEATURE_IDS.HALLOWEEN]: false,
  },
  // How many times has each seasonal feature been seen (in this session)?
  seasonalFeaturesSeenCount: {
    [SEASONAL_FEATURE_IDS.HALLOWEEN]: 0,
  },
  clientA11yFeatures: false,
  allowPrototypePlaytesting: false,
};

export const FEATURE_TOGGLE_TYPES = {
  SEASONAL_ANIMATION_COMPLETE: 'SEASONAL_ANIMATION_COMPLETE',
  TOGGLE_SEASONAL_FEATURE: 'TOGGLE_SEASONAL_FEATURE',
  RESPONSE_GET_FEATURE_TOGGLES: 'RESPONSE_GET_FEATURE_TOGGLES',
  REQUEST_GET_FEATURE_TOGGLES: 'REQUEST_GET_FEATURE_TOGGLES',
  ERROR_GET_FEATURE_TOGGLES: 'ERROR_GET_FEATURE_TOGGLES',
  SET_FEATURE: 'SET_FEATURE',
};
/**
 * This reducer tracks what features or adjustments to the App (eg, Color themes, bonus levels, or other adjustments)
 * should be toggled on or off for the logged-in user. It could be used for A/B testing or seasonal Easter Eggs
 * (eg, for Halloween)
 */
const featureToggleReducer = (state = initState, { type, payload }) => {
  switch (type) {
    case FEATURE_TOGGLE_TYPES.SEASONAL_ANIMATION_COMPLETE:
      return {
        ...state,
        seasonalFeaturesSeenCount: {
          ...state.seasonalFeaturesSeenCount,
          [payload.seasonalKey]: state.seasonalFeaturesSeenCount[payload.seasonalKey] + 1,
        },
      };
    case FEATURE_TOGGLE_TYPES.TOGGLE_SEASONAL_FEATURE:
      return {
        ...state,
        seasonalAdjustmentFeatures: {
          ...state.seasonalAdjustmentFeatures,
          [payload.seasonalKey]: !state.seasonalAdjustmentFeatures[payload.seasonalKey],
        },
      };
    case FEATURE_TOGGLE_TYPES.RESPONSE_GET_FEATURE_TOGGLES:
      return {
        ...state,
        ...payload,
      };
    case FEATURE_TOGGLE_TYPES.SET_FEATURE:
      return {
        ...state,
        ...(payload.feature ? { [payload.feature]: payload.value } : {}),
      };
    default:
      return state;
  }
};

export default featureToggleReducer;
